// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"40c902fc","453":"9e5db528"}[chunkId] + ".chunk.js";
};